import { SVGProps } from 'react'

export const HeadingFourIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 24"
    fill="none"
    {...props}
  >
    <path
      d="M6 20V4M6 12H18M18 20V4"
      stroke="#364359"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <text
      x="22"
      y="21"
      fill="#98A2B3"
      fontFamily="Arial, sans-serif"
      fontSize="18"
      fontWeight="bold"
    >
      4
    </text>
  </svg>
)
